import DefaultMapper, { toPagingAndSorting, mapId, mapIdInList, addCustomMethods } from 'cw-core-admin-ui/src/dataProvider/DefaultMapper';
import { stringify } from 'query-string';
import { API_BASE_PATH_DEMOWALLET_ADMIN } from '../../constants';

class ShopConfigurationMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'shop/configurations';
	}

	prepareCreate({ type, resource, params, options, mappedResource }) {
		options.method = 'POST';
		options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}/${params.id}${addCustomMethods(params)}`;
		options.body = JSON.stringify(params.data);
	}

	prepareGetList({ type, resource, params, options, mappedResource }) {
		const query = {
			...params.filter,
			...toPagingAndSorting(params),
		};
		options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}?${stringify(query)}`;
	}

	finishGetList({ result }) {
		return mapIdInList(super.finishGetList({ result }), 'shopConfigurationId');
	}

	prepareGetOne({ type, resource, params, options, mappedResource }) {
		options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}/${params.id}`;
	}

	finishGetOne({ type, resource, params, options, mappedResource, result }) {
		return mapId(super.finishGetOne({ result }), 'shopConfigurationId');
	}
}

export default ShopConfigurationMapper;
